import { all, call, takeLatest, put, select } from 'redux-saga/effects'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'

import * as actions from './actions'
import * as services from './services'
import { getUserById } from '../users/services'
import { roles } from '../../utils/constants'

export function * fetchSchoolContentCreatorsById ({ payload }) {
  try {
    const response = yield call(services.fetchContentCreatorById, payload)
    yield put(actions.getSchoolContentCreatorsByIdSuccessful(response))
  } catch (error) {
    yield put(actions.getSchoolContentCreatorsByIdFailure(error))
  }
}

export function * fetchSchoolAdministratorById ({ payload }) {
  try {
    const response = yield call(services.fetchAdministratorById, payload.id)
    yield put(
      actions.getSchoolAdministratorByIdSuccessful({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * fetchSchoolTeacherById ({ payload }) {
  try {
    const response = yield call(services.fetchTeacherById, {
      id: payload.id,
      params: {
        'q[school_app_schools_app_user_application_id_eq]':
          process.env.REACT_APP_PROJECT_ID
      }
    })
    yield put(
      actions.getSchoolTeacherByIdSuccessful({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * fetchSchoolCoordinatorById ({ payload }) {
  try {
    const response = yield call(services.fetchCoordinatorById, payload.id)
    yield put(
      actions.getSchoolCoordinatorByIdSuccessful({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * updateLayoutSchoolRequest ({ payload }) {
  try {
    const { auth } = yield select()
    const userOccupations = auth.user.data?.attributes?.occupations
    const file = payload.avatar[0]
    const fd = new FormData()
    fd.append('data[type]', 'schools')
    fd.append('data[id]', payload.id)
    typeof file === 'object' && fd.append('data[attributes][avatar]', file)
    fd.append('data[attributes]primary_color', payload.primary_color)
    fd.append('data[attributes]secondary_color', payload.secondary_color)
    const response = yield call(services.updateLayoutSchool, {
      id: payload.id,
      data: fd
    })
    yield put(
      actions.updateLayoutSchoolSuccessful(
        userOccupations.includes(roles.SCHOOL_ADMIN) ? response.data : {}
      )
    )
  } catch (error) {
    yield put(actions.updateLayoutSchoolFailure(error))
  }
}

export function * fetchSchools ({ payload }) {
  try {
    const response = yield call(services.fetchSchools, payload)
    yield put(actions.getSchoolsSuccessful(response))
  } catch (error) {
    yield put(actions.getSchoolsFailure(error))
  }
}

export function * saveSelectedSchool ({ payload }) {
  yield put(actions.selectedCurrentSchoolSuccessful(payload))
}

export function * fetchSchoolConfig ({ payload }) {
  try {
    const response = yield call(services.getSchoolConfig, payload)
    yield put(actions.getSchoolConfigSuccessFul(response))
  } catch (error) {
    console.error(error)
    yield put(actions.getSchoolConfigFailure(error))
  }
}

export function * updateSchoolConfig ({ payload }) {
  try {
    const response = yield call(services.updateSchoolConfig, payload)
    yield put(actions.changeSchoolConfigSuccessful(response))
  } catch (err) {
    console.error(err)
    yield put(actions.changeSchoolConfigFailure(err))
  }
}

export function * getSchoolFinanceByIdRequest ({ payload }) {
  try {
    const response = yield call(services.fetchSchoolFinanceByUserId, payload.id)
    yield put(
      actions.getSchoolFinanceByIdSuccess({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * getSchoolSecretaryByIdRequest ({ payload }) {
  try {
    const response = yield call(
      services.fetchSchoolSecretaryByUserId,
      payload.id
    )
    yield put(
      actions.getSchoolSecretaryByIdSuccess({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * getSchoolOmbudsmanRequest ({ payload }) {
  try {
    const response = yield call(
      services.fetchSchoolOmbudsmanByUserId,
      payload.id
    )
    yield put(
      actions.getSchoolOmbudsmanByIdSuccess({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * getSchoolPsychologistRequest ({ payload }) {
  try {
    const response = yield call(
      services.fetchSchoolPsychologistByUserId,
      payload.id
    )
    yield put(
      actions.getSchoolPsychologistByIdSuccess({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * getSchoolNurseRequest ({ payload }) {
  try {
    const response = yield call(services.fetchSchoolNurseByUserId, payload.id)
    yield put(
      actions.getSchoolNurseByIdSuccess({
        response
      })
    )
  } catch (error) {
    yield put(actions.getSchoolOccupationByIdFailure(error))
  }
}

export function * getSchoolParentRequest ({ payload }) {
  try {
    const response = yield call(getUserById, { id: payload.id })
    const schoolsUser = response?.classrooms.map(classroom => classroom.school)
    const uniqueSchools = Array.from(
      new Map(schoolsUser.map(school => [school.id, school])).values()
    ).map(school => ({ school }))

    const schoolsWithCompletResource = yield all(
      uniqueSchools.map(function * (school) {
        const schoolsById = yield call(services.fetchSchools, school.school.id)
        return schoolsById?.[0]
      })
    )
    yield put(
      actions.getSchoolParentByIdSuccessful({
        response: schoolsWithCompletResource.map(item => ({ school: item }))
      })
    )
  } catch (err) {
    console.error(err)
    yield put(actions.getSchoolOccupationByIdFailure(err))
  }
}

export function * switchSchoolRequest ({ payload }) {
  try {
    yield put(actions.switchSchoolSuccessful(payload))
    yield put(actions.clearSchoolConfig())
    if (payload?.school_id) {
      yield put(actions.getSchoolConfig(payload.school_id))
    }
  } catch (err) {
    yield put(actions.switchSchoolFailure(err))
  }
}

export function * getSchoolTeacherRSPA (action) {
  try {
    const { payload } = action
    const response = yield call(services.fetchSchoolTeachers, payload)
    resolvePromiseAction(action, response)
  } catch (err) {
    console.error(err)
    rejectPromiseAction(action, err)
  }
}

export function * watchFetchSchoolContentCreators () {
  yield takeLatest(
    actions.getSchoolContentCreatorsById,
    fetchSchoolContentCreatorsById
  )
  yield takeLatest(
    actions.getSchoolAdministratorById,
    fetchSchoolAdministratorById
  )
  yield takeLatest(actions.updateLayoutSchool, updateLayoutSchoolRequest)
  yield takeLatest(actions.getSchoolTeacherById, fetchSchoolTeacherById)
  yield takeLatest(actions.getSchools, fetchSchools)
  yield takeLatest(actions.selectedCurrentSchool, saveSelectedSchool)
  yield takeLatest(actions.getSchoolCoordinatorById, fetchSchoolCoordinatorById)
  yield takeLatest(actions.getSchoolConfig, fetchSchoolConfig)
  yield takeLatest(actions.changeSchoolConfig, updateSchoolConfig)
  yield takeLatest(actions.getSchoolParentById, getSchoolParentRequest)
  yield takeLatest(actions.getSchoolNurseById, getSchoolNurseRequest)
  yield takeLatest(
    actions.getSchoolPsychologistById,
    getSchoolPsychologistRequest
  )
  yield takeLatest(actions.getSchoolOmbudsmanById, getSchoolOmbudsmanRequest)
  yield takeLatest(
    actions.getSchoolSecretaryById,
    getSchoolSecretaryByIdRequest
  )
  yield takeLatest(actions.getSchoolFinanceById, getSchoolFinanceByIdRequest)
  yield takeLatest(actions.switchSchool, switchSchoolRequest)
  yield takeLatest(actions.getSchoolTeacherRSPA.request, getSchoolTeacherRSPA)
}

export default function * schoolContentCreatorsSagas () {
  yield all([watchFetchSchoolContentCreators()])
}
